<template>
    <svg :height="height" :width="width" viewBox="0 0 100 100" >
        <path fill="currentColor" style="stroke:none;stroke-width:2;marker:none;"
        d="m 22.916666,12.500032 c -2.308373,0 -4.166666,1.858332 -4.166666,4.166663 l 0,66.66661 c 0,2.083331 2.083333,4.166663 4.166666,4.166663 l 37.500001,0 c 2.083333,0 4.166666,-2.083332 4.166666,-4.166663 l 0,-20.833316 2.083334,0 c 2.083333,0 2.083333,2.083332 2.083333,2.083332 l 0,8.333326 c 0,4.166663 2.083333,6.249995 6.25,6.249995 4.166667,0 6.25,-2.083332 6.25,-6.249995 0,-4.861246 0,-18.749984 0,-22.916647 0,-4.166663 -8.333333,-8.333326 -8.333333,-12.499989 l 0,-12.49999 -4.166667,0 -4.166667,-4.166663 0,-4.166663 c 0,-2.308331 -1.858291,-4.166663 -4.166666,-4.166663 z m 4.166667,8.333326 29.166667,0 0,16.666653 -29.166667,0 z m 37.5,12.49999 4.166667,0 c 0,0 0,3.47208 0,6.249994 0,4.166663 8.333334,8.333326 8.333334,12.49999 l 0,20.833315 C 77.083334,74.999979 75,74.999979 75,74.999979 c 0,0 -2.083333,0 -2.083333,-2.083332 0,0 0,-8.333326 0,-10.416658 0,-2.083331 -2.083334,-4.166663 -4.166667,-4.166663 -1.388887,0 -4.166667,0 -4.166667,0 z" />
    </svg>
</template>

<script>
export default {
  name: 'GasIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>
